export default "__VITE_ASSET__57eb7565__"